import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import i18n from "i18next";
import { Alert, Modal, Spin, Table, Typography } from "antd";
import { ServiceRepository as ServiceActions } from "../../redux/ServiceActions";

const { Link, Text, Title } = Typography;
const valueOf = (binding, name) => typeof binding?.[name] === "object" ? binding[name].value : binding?.[name];

function TranslateLangCheck({ open, onClose, dispatch, router }) {
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!open) return undefined;
    let active = true;
    setLoading(true); setRows([]); setError(null);
    dispatch(ServiceActions.loadTranslateLangCheck()).then((response) => {
      if (!active) return;
      const bindings = response?.results?.bindings || response?.bindings || [];
      setRows(bindings.map((item, key) => ({ key, subject: valueOf(item, "subject"),
        predicate: valueOf(item, "predicate"), language: valueOf(item, "language"),
        count: valueOf(item, "count"), violation: valueOf(item, "violation") })));
    }).catch((reason) => { if (active) setError(reason?.message || String(reason)); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [open, dispatch]);

  const columns = [
    { title: i18n.t("service.translateLangCheck.columns.subject"), dataIndex: "subject", key: "subject", render: (subject) => {
      if (!subject) return "—";
      const href = `/individual/${encodeURIComponent(subject)}`;
      return <>{subject}</>;
      // return <Link href={href} onClick={router?.navigate ? (event) => {
      //   event.preventDefault(); onClose?.(); router.navigate(href);
      // } : undefined}>{subject}</Link>;
    } },
    { title: i18n.t("service.translateLangCheck.columns.predicate"), dataIndex: "predicate", key: "predicate" },
    { title: i18n.t("service.translateLangCheck.columns.language"), dataIndex: "language", key: "language", width: 110, render: (value) => value || i18n.t("service.translateLangCheck.noLanguageTag") },
    { title: i18n.t("service.translateLangCheck.columns.count"), dataIndex: "count", key: "count", width: 90 },
    { title: i18n.t("service.translateLangCheck.columns.violation"), dataIndex: "violation", key: "violation" },
  ];

  return <Modal title={<Title level={5} style={{ margin: 0 }}>{i18n.t("service.translateLangCheck.title")}</Title>}
    open={open} onCancel={onClose} onOk={onClose} okText={i18n.t("service.translateLangCheck.close")}
    cancelButtonProps={{ style: { display: "none" } }} width="90%"
    maskClosable={!loading} closable={!loading}>
    {loading ? <div style={{ padding: 40, textAlign: "center" }}><Spin size="large" />
      <div style={{ marginTop: 16 }}><Text>{i18n.t("service.translateLangCheck.checking")}</Text></div></div>
      : error ? <Alert type="error" showIcon message={i18n.t("service.translateLangCheck.requestError")} description={error} />
      : rows.length ? <Table columns={columns} dataSource={rows} pagination={{ pageSize: 10, showSizeChanger: true }} scroll={{ x: 1100 }} size="small" />
      : <Alert type="success" showIcon message={i18n.t("service.translateLangCheck.noViolations")} />}
  </Modal>;
}

export default connect()(TranslateLangCheck);
